// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import ResponsiveImage from '../../../ResponsiveImage';

type PropTypes = {|
  imageSize: 'Small' | 'Medium',
  image: string,
  alt?: string,
  children: React.Node,
  className?: string,
|};

const BaseColumn = (props: PropTypes) => {
  const classname = cx(styles.image, props.imageSize === 'Small' && styles.isSmall);
  return (
    <div className={cx(styles.container, props.className)}>
      <ResponsiveImage
        className={classname}
        src={props.image}
        alt={props.alt}
        defaultSize={{ width: 560, height: 180 }}
      />
      {props.children}
    </div>
  );
};

BaseColumn.defaultProps = {
  imageSize: 'Medium',
};

export default BaseColumn;
